import React from 'react';
import MarketList from './MarketList';

export default function USDTMarket({ intent = 'sell' }) {
  return <MarketList intent={intent} coin="USDT" />;
}
